module.exports = __webpack_public_path__ + "img/marmelaedchen-eingang_xs.b3df2445.jpg";